import React from "react";
import { useEventStore } from "../../store";
import styles from "./ui.module.scss";
import moment from "moment";

const EventDate = () => {
  const { eventDate, uiStore } = useEventStore();
  if (!eventDate) return null;

  const start_date = new Date(
    new Date(eventDate?.event_start).toUTCString().slice(0, -4)
  );
  const end_date = new Date(
    new Date(eventDate?.event_end).toUTCString().slice(0, -4)
  );

  const isOneMonth = start_date.getMonth() === end_date.getMonth();
  const isOneYear = start_date.getFullYear() === end_date.getFullYear();

  const monthFormat =
    (!isOneMonth || !isOneYear) && uiStore.isMobile ? " MMM" : " MMMM";

  const firstDate = `${moment(start_date)
    .utc()
    .format(
      `D${isOneMonth && isOneYear ? "" : monthFormat} ${
        isOneYear ? "" : "YYYY"
      }`
    )}`;
  const secondDate = `${moment(end_date).utc().format(`D${monthFormat} YYYY`)}`;

  if (
    moment(start_date).utc().format("DD MMMM YYYY") ===
    moment(end_date).utc().format("DD MMMM YYYY")
  ) {
    return (
      <div className={styles.EventDate}>
        <img
          src="/static/images/eventIcons/CalendarBlank.svg"
          alt="Календарь"
        />
        <span>{secondDate.replace(".", "")}</span>
      </div>
    );
  }

  return (
    <div className={styles.EventDate}>
      <img src="/static/images/eventIcons/CalendarBlank.svg" alt="Календарь" />
      <span>
        {firstDate.replace(".", "")} - {secondDate.replace(".", "")}
      </span>
    </div>
  );
};

export default EventDate;
